import { Gray100 } from '@zep-us/zus/tokens';

import {
  SOLID_COLOR_HEX,
  SOLID_COLOR_IDS,
  type SolidColorId,
} from '@/shared/consts/solidColors';

import type { FolderColor } from '../types/folder.types';

const isFolderColor = (id: SolidColorId): id is FolderColor => id !== 'GRAY';

/**
 * 폴더 색 목록. 보드 배경 단색에서 회색만 뺀 것이고, 피커 칸 순서다.
 * 회색은 고르기 전 폴더 색(`FOLDER_DEFAULT_HEX`)과 눈으로 거의 같아 뺐다.
 */
export const FOLDER_COLORS: readonly FolderColor[] =
  SOLID_COLOR_IDS.filter(isFolderColor);

/** 고르기 전(기본) 폴더 색 — 지금까지의 회색 폴더 모양 그대로다. */
export const FOLDER_DEFAULT_HEX = Gray100;

/** 화면에 칠할 폴더 색. 고르기 전이면 기본 회색이다. */
export const folderColorHex = (color: FolderColor | undefined): string =>
  color ? SOLID_COLOR_HEX[color] : FOLDER_DEFAULT_HEX;

/**
 * 서버 값 → 폴더 색. 서버는 형식만 보고 저장하므로 목록에 없는 id 가 올 수 있다 — 그때는 `undefined`.
 */
export const toFolderColor = (
  value: string | null | undefined,
): FolderColor | undefined => FOLDER_COLORS.find(color => color === value);

/**
 * 모델에 펼칠 고른 색. 서버는 고른 적이 없으면 null 을 주고, 모델에서는 필드를 비운다.
 * 목록에 없는 색(예: 처음 5색 시절의 ORANGE, 폴더에서 뺀 GRAY)도 고르기 전과 같이 본다.
 */
export const toPickedFolderColor = (
  value: string | null | undefined,
): { color?: FolderColor } => {
  const color = toFolderColor(value);
  return color ? { color } : {};
};
